import {createStrokeSVG} from './TEMPLATE'

// tabler: inbox
export const Inbox_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12',
    'M4 13h3l3 3h4l3 -3h3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: inbox
export const Inbox_Stroke2_Corner2_Rounded_Large = createStrokeSVG({
  paths: [
    'M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12',
    'M4 13h3l3 3h4l3 -3h3',
  ],
  viewBox: '2 2 20 20',
  strokeWidth: 2,
})
